import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-1cc53b51"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "e-message__content" };
var _hoisted_2 = {
    key: 0,
    class: "e-message__title"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
    key: 0,
    class: "e-message__text"
};
var _hoisted_5 = ["innerHTML"];
import EIconMessage from '@common/ui/EIcon.vue';
import { computed, getCurrentInstance, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EMessage',
    props: {
        type: { default: 'info' },
        message: {},
        onClose: {},
        onAfterClose: {},
        duration: { default: 3000 },
        startedVerticalOffset: { default: 60 },
        zIndex: {}
    },
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var props = __props;
        var icons = {
            success: 'success-notify',
            info: 'info-notify',
            warning: 'warning-notify',
            error: 'error-notify',
        };
        var messageRef = ref();
        var verticalOffset = ref(null);
        var visible = ref(false);
        var data = reactive({
            iconClass: '',
            customClass: '',
            showClose: false,
            timer: null,
            dangerouslyUseHTMLString: false,
            center: false,
            text: '',
            defaultBoundaries: null,
            clientX: null,
        });
        var computedVerticalOffset = computed(function () {
            return verticalOffset.value !== null ? verticalOffset.value : props.startedVerticalOffset;
        });
        var instance = getCurrentInstance();
        var positionStyle = computed(function () {
            return {
                bottom: "".concat(computedVerticalOffset.value, "px"),
                zIndex: props.zIndex
            };
        });
        var icon = computed(function () {
            return icons[props.type];
        });
        var isFullNotify = computed(function () {
            return data.text && props.message;
        });
        onMounted(function () {
            startTimer();
            document.addEventListener('keydown', keydown);
        });
        onBeforeUnmount(function () {
            document.removeEventListener('keydown', keydown);
        });
        var handleAfterLeave = function () {
            props.onAfterClose && props.onAfterClose();
        };
        var open = function () {
            visible.value = true;
        };
        var close = function () {
            visible.value = false;
            props.onClose && props.onClose();
        };
        var clearTimer = function () {
            if (!data.timer) {
                return;
            }
            clearTimeout(data.timer);
        };
        var startTimer = function () {
            if (props.duration > 0) {
                data.timer = setTimeout(function () {
                    if (visible.value) {
                        close();
                    }
                }, props.duration);
            }
        };
        var keydown = function (e) {
            if (e.keyCode === 27 && !data.closed) {
                close();
            }
        };
        var onMouseDown = function (e) {
            if (!data.defaultBoundaries) {
                data.defaultBoundaries = messageRef.value.getBoundingClientRect();
            }
            data.clientX = e.clientX;
            document.body.style.cursor = 'grabbing';
            document.addEventListener('mousemove', mouseMove);
            document.addEventListener('mouseup', mouseUp);
        };
        var mouseMove = function (e) {
            var pxMove = e.clientX - data.clientX;
            var rightPadding = window.innerWidth - data.defaultBoundaries.right - pxMove;
            if (pxMove < 0) {
                return;
            }
            messageRef.value.style.right = rightPadding + 'px';
            messageRef.value.style.opacity = String((data.defaultBoundaries.width / 100) / pxMove);
        };
        var mouseUp = function () {
            data.clientX = null;
            if (messageRef.value.getBoundingClientRect().right - data.defaultBoundaries.right >= 10) {
                close();
            }
            else {
                messageRef.value.style.right = window.innerWidth - data.defaultBoundaries.right + 'px';
                messageRef.value.style.opacity = 1;
            }
            document.body.style.cursor = '';
            document.removeEventListener('mousemove', mouseMove);
            document.removeEventListener('mouseup', mouseUp);
        };
        var updateOffset = function (offset) {
            verticalOffset.value = offset;
        };
        var getHeight = function () {
            return messageRef.value.getBoundingClientRect().height;
        };
        __expose({
            open: open,
            close: close,
            updateOffset: updateOffset,
            getHeight: getHeight
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            return (_openBlock(), _createBlock(_Transition, {
                name: "e-message-fade",
                onAfterLeave: handleAfterLeave
            }, {
                default: _withCtx(function () { return [
                    _withDirectives(_createElementVNode("div", {
                        ref_key: "messageRef",
                        ref: messageRef,
                        class: _normalizeClass([
                            'e-message',
                            props.type && !data.iconClass ? "e-message--".concat(props.type) : '',
                            data.center ? 'is-center' : '',
                            data.showClose ? 'is-closable' : '',
                            data.customClass
                        ]),
                        style: _normalizeStyle(positionStyle.value),
                        role: "alert",
                        onMousedown: _cache[0] || (_cache[0] = _withModifiers(function ($event) { return (onMouseDown($event)); }, ["prevent"])),
                        onMouseenter: clearTimer,
                        onMouseleave: startTimer
                    }, [
                        _createElementVNode("div", {
                            class: _normalizeClass([[
                                    isFullNotify.value ? 'e-message__icon-wrapper-box' : ''
                                ], "e-message__icon-wrapper"])
                        }, [
                            _createVNode(_component_e_icon, {
                                icon: icon.value,
                                class: "e-message__icon"
                            }, null, 8, ["icon"])
                        ], 2),
                        _createElementVNode("div", _hoisted_1, [
                            (props.message)
                                ? _renderSlot(_ctx.$slots, "default", { key: 0 }, function () { return [
                                    (!data.dangerouslyUseHTMLString)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(props.message), 1))
                                        : (_openBlock(), _createElementBlock("p", {
                                            key: 1,
                                            class: "e-message__title",
                                            innerHTML: props.message
                                        }, null, 8, _hoisted_3))
                                ]; })
                                : _createCommentVNode("", true),
                            (data.text)
                                ? _renderSlot(_ctx.$slots, "default", { key: 1 }, function () { return [
                                    (!data.dangerouslyUseHTMLString)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(data.text), 1))
                                        : (_openBlock(), _createElementBlock("p", {
                                            key: 1,
                                            class: "e-message__text",
                                            innerHTML: data.text
                                        }, null, 8, _hoisted_5))
                                ]; })
                                : _createCommentVNode("", true)
                        ]),
                        (data.showClose)
                            ? (_openBlock(), _createBlock(EIconMessage, {
                                key: 0,
                                class: "e-message__closer",
                                icon: "close",
                                onClick: close
                            }))
                            : _createCommentVNode("", true)
                    ], 38), [
                        [_vShow, visible.value]
                    ])
                ]; }),
                _: 3
            }));
        };
    }
});
